import { Profile } from 'features/profiles/useProfiles';

/**
 * 1-based hypothetical rank while excluding one profile from an already-sorted
 * roster. This avoids rebuilding an O(n) peer array for every profile.
 */
export const rankAmongProfilesExcluding = (
  rankedProfiles: readonly Profile[],
  excludedProfile: Profile,
  selfScore: number,
  selfUpdatedMs: number
): number => {
  let lo = 0;
  let hi = rankedProfiles.length;
  while (lo < hi) {
    const mid = (lo + hi) >> 1;
    const peer = rankedProfiles[mid];
    const peerBeatsSelf =
      peer.sortScore !== selfScore ? peer.sortScore > selfScore : peer.lastUpdated.getTime() < selfUpdatedMs;
    if (peerBeatsSelf) lo = mid + 1;
    else hi = mid;
  }

  const excludedBeatsSelf =
    excludedProfile.sortScore !== selfScore
      ? excludedProfile.sortScore > selfScore
      : excludedProfile.lastUpdated.getTime() < selfUpdatedMs;
  return lo + 1 - Number(excludedBeatsSelf);
};
